"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const generated_1 = require("./generated");
class QualifiedName {
    constructor(options) {
        var _a, _b, _c, _d;
        this.NamespaceIndex = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NamespaceIndex, (_b !== null && _b !== void 0 ? _b : 0));
        this.Name = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Name, (_d !== null && _d !== void 0 ? _d : ''));
    }
}
__decorate([
    generated_1.Type('uint16'),
    __metadata("design:type", typeof (_a = typeof uint16 !== "undefined" && uint16) === "function" ? _a : Object)
], QualifiedName.prototype, "NamespaceIndex", void 0);
__decorate([
    generated_1.Type('string'),
    __metadata("design:type", String)
], QualifiedName.prototype, "Name", void 0);
exports.default = QualifiedName;
